import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { X } from 'lucide-react';

export interface ModalProps {
    open: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    icon?: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
    maxWidth?: string;
    zIndex?: number;
}

export const Modal: React.FC<ModalProps> = ({
    open,
    onClose,
    title,
    icon,
    children,
    footer,
    maxWidth = 'max-w-md',
    zIndex = 70,
}) => {
    return (
        <AnimatePresence>
            {open && (
                <div
                    className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
                    style={{ zIndex }}
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.96 }}
                        transition={{ duration: 0.15 }}
                        className={`bg-surface border border-border rounded-lg w-full ${maxWidth} max-h-[90vh] shadow-2xl overflow-hidden flex flex-col`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {title !== undefined && (
                            <div className="flex items-center justify-between px-5 py-4 border-b border-border shrink-0">
                                <h2 className="text-sm font-bold text-content flex items-center gap-2">
                                    {icon}
                                    {title}
                                </h2>
                                <button
                                    onClick={onClose}
                                    className="p-1.5 text-content-muted hover:text-content rounded-md hover:bg-surface-soft transition-colors"
                                >
                                    <X size={16} />
                                </button>
                            </div>
                        )}

                        <div className="p-5 overflow-y-auto flex-1">{children}</div>

                        {footer !== undefined && (
                            <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-border bg-surface-soft shrink-0">
                                {footer}
                            </div>
                        )}
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};
